import ComponentManager from '@/Management/ComponentManager';
import Link from '@/Controls/Link';
import MultilineTextBoxPopUpLinkViewModel from '@/Components/Links/MultilineTextBoxPopUpLink/MultilineTextBoxPopUpLinkViewModel';
import Window from '@/Controls/Window';
import type MultilineTextBoxType from '@/Controls/MultilineTextBox';
import type ButtonType from '@/Controls/Button';

export default class MultilineTextBoxPopUpLink extends Link {
   
    /**
    * @override
    */
    protected viewModel: MultilineTextBoxPopUpLinkViewModel;
    private window: Window;
    private MultilineTextBox = ComponentManager.getControl<typeof MultilineTextBoxType>('MultiLineTextBox');
    private Button = ComponentManager.getControl<typeof ButtonType>('Button');

    public constructor(viewModel: MultilineTextBoxPopUpLinkViewModel) {
        super(viewModel);

        viewModel.setOnOpenCallback(() => {
            this.disposeWindow();
            this.window = this.createWindow();
        });

        viewModel.setOnCloseCallback(() => {
            this.disposeWindow();
        });
    }

    /**
    * @override
    */
    public getControl(): JQuery {
        const control = super.getControl();
        this.applyBindings(control, {
            controlName: 'multilinetextboxpopuplink'
        });

        return control;
    }

    private createWindow(): Window {
        const windowVms = this.viewModel.createWindowViewModels();
        const window = new Window(windowVms.window);

        const windowControl = window.getControl();
        windowControl.addClass('multilinetextboxpopup');
        windowControl.appendTo(this.jQueryControl);

        // Dies muss eine Subscription bleiben, da der content von Kendo ausgetauscht wird
        windowVms.window.defineSubscription(windowVms.window.content, (content) => {
            const body = $('<div class="body">').appendTo(content);
            const footer = $('<div class="footer"></div>').appendTo(content);

            const textBox = new this.MultilineTextBox(windowVms.textBox);
            const textBoxControl = textBox.getControl();
            textBoxControl.appendTo(body);

            for (let buttonVm of windowVms.buttons) {
                const button = new this.Button(buttonVm, $('<button>'));
                button.getControl().appendTo(footer);
            }

        }, true);

        return window;
    }

    private disposeWindow(): void {
        if (this.window) {
            this.window.dispose();
            this.window = null;
        }
    }
}

ComponentManager.setControl('MultilineTextBoxPopUpLink', MultilineTextBoxPopUpLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');